import { sortBy, filter, find } from "lodash";
import gql from "graphql-tag";

export default {
	data() {
		return {
			loadTypes: null
		};
	},
	computed: {
		_apps() {
			if (!this._companies) return [];

			return sortBy(this._companies, ["State.approved", "State.declined", "name"]);
		}
	},
	apollo: {
		_companies: {
			query: gql`
				query Companies {
					Companies {
						id
						name
						application_name
						slug
						classroom_uuid
						CompanyTypes {
							company_sp_enabled
							company_association
							sso
							sync
							tile
						}
						Icon {
							type
							value
						}
						Associations {
							uuid
							classroom_uuid
						}
						State {
							approved
							declined
						}
					}
				}
			`,
			update: r => {
				return r.Companies.filter(company => {
					if (!this.loadTypes) return true;

					return Object.keys(this.loadTypes).find(type => {
						if (!this.loadTypes[type]) return false;

						if (company.CompanyTypes[type]) return true;
					});
				});
			}
		}
	},
	methods: {
		_filterApps(types) {
			if (types) {
				if (typeof types === "string") {
					types = [types];
				}

				return filter(this._apps, app => find(types, type => app.CompanyTypes[type]));
			}

			return this._apps;
		}
	}
};



// WEBPACK FOOTER //
// ./src/components/mixins/loadAllApplicationTypes.mixin.js